import React from 'react';
import {observer} from 'mobx-react';
import {TechseeBaseComponent} from '@techsee/techsee-ui-common/lib/_shared/techsee-base-component';

import './ts-capture-image.styles.scss';

export interface ITsCaptureImageProps {
    onVideoClicked: () => void;
    displayButtonsInVideo: boolean;
    displayNewScanMode: boolean;
}

@observer
export class TsCaptureImage extends TechseeBaseComponent<ITsCaptureImageProps> {
    renderInternal(): JSX.Element {
        const {onVideoClicked, displayButtonsInVideo, displayNewScanMode} = this.props;

        if (!displayButtonsInVideo) {
            return <></>;
        }

        return (
            <div
                id='ts-capture-image'
                className={`ts-capture-image ${displayNewScanMode ? 'new-scan' : ''}`}
                onClick={onVideoClicked}>
                <div className='glyphicon glyphicon-camera'></div>
            </div>
        );
    }
}
